// export enum PATH {
//   PROFILE = '/profile',
//   LOGIN_FORM = '/',
//   LOGIN = 'login',
//   REGISTER = 'register',
//   NEW_PASSWORD = 'new_pass',
//   RECOVERY_PASSWORD = 'recovery',
//   ERROR = '404',
//   WRONG_PAGE = '*',
//   TEST_PAGE = 'test',
//   CARDS = '/cards/',
//   CARDS_PACK_TABLE = 'cards_pack_table',
//   CARDS_TABLE = 'cards_table',
//   LEARN = 'learn',
// }

export enum PATH {
  MAIN = '/',
  PROFILE = '/profile',
  LOGIN_FORM = '/login_form',
  LOGIN = 'login',
  REGISTER = 'register',
  NEW_PASSWORD = 'new_pass',
  RECOVERY_PASSWORD = 'recovery',
  ERROR = '404',
  WRONG_PAGE = '*',
  TEST_PAGE = 'test',
  CARDS = '/cards',
  // CARDS_PACK_TABLE = 'cards_pack_table',
  // PACKS = '/packs',
  CARDS_TABLE = '/cards_table',
  LEARN = '/learn',
}
